import React from "react";
import { motion } from "framer-motion";
import { Container, Overline, EASE } from "@/components/primitives";
import { PrismHero, PrismBackground, FloatingShard } from "@/components/Prism";

// Shared inner page hero with prism visual.
export const PageHero = ({ overline, title, highlight, description, testid }) => {
  const renderTitle = () => {
    if (!highlight) return title;
    const parts = title.split(highlight);
    return (
      <>
        {parts[0]}
        <span className="text-gradient-cyan">{highlight}</span>
        {parts[1]}
      </>
    );
  };
  return (
    <section
      className="relative overflow-hidden pt-36 pb-16 md:pt-44 md:pb-20"
      data-testid={testid}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-axor-hero via-axor-deep to-axor-deep" />
      <div className="light-rays absolute inset-0" />
      <PrismBackground />
      <Container className="relative grid items-center gap-10 lg:grid-cols-[1.2fr_0.8fr]">
        <div>
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
            <Overline>{overline}</Overline>
          </motion.div>
          <motion.h1
            className="mt-6 max-w-2xl text-4xl font-semibold leading-[1.08] tracking-tight text-axor-white sm:text-5xl lg:text-6xl"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: EASE, delay: 0.1 }}
          >
            {renderTitle()}
          </motion.h1>
          {description && (
            <motion.p
              className="mt-6 max-w-xl text-lg leading-relaxed text-axor-text"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, delay: 0.25 }}
            >
              {description}
            </motion.p>
          )}
        </div>
        <div className="relative hidden justify-center lg:flex">
          <PrismHero className="w-40" />
          <FloatingShard className="right-4 top-6 h-8 w-8" shape="diamond" delay={0.5} />
        </div>
      </Container>
    </section>
  );
};
